module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/DesktopHeroPoster-0dcb65c23732059f0cee05f054cfbf93.jpg";